import { globalBreak } from "@/styles/break";
import { SxProps } from "@mui/material";

export const AccordionSX = (isBorder:boolean) : SxProps => ({
    py: 0.5,
    borderBottom: isBorder ? '1px solid lightgrey' : 'none',
})

export const AccordionSummarySX:SxProps = {
    '& div':{
        fontSize:globalBreak({mobile:14, desktop:16})
    },
}

export const AccordionDetailsSX:SxProps = {
    px:3,
    py:1,
    '& div':{
        fontSize:globalBreak({mobile:14, desktop:15})
    },
}